<div class="date-range-picker-form-field">
  <mat-form-field appearance="fill">
    <div class="ds-input-wrap compare-dates">
      <mat-date-range-input [formGroup]="range" [rangePicker]="picker" class="hidden">
        <input matStartDate formControlName="start" [placeholder]="'text_startDate' | dbText" />
        <input matEndDate formControlName="end" [placeholder]="'text_endDate' | dbText" />
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker">
        <mat-icon matDatepickerToggleIcon>
          <div class="custom-dates">
            <span class="mr20"><img src="assets/images/ecommerce/payengine/date-picker.svg" class="mr8" >{{choosenDates}}</span>
            <p>{{ 'text_compareTo' | dbText }} <span class="ml6">{{comparedDates}}</span></p>
          </div>
          <i class="db-icon db-icon-ds-arrow-small"></i>
        </mat-icon>
      </mat-datepicker-toggle>
    </div>

    <mat-date-range-picker
            #picker
            [calendarHeaderComponent]="CustomHeaderComponent"
    ><mat-date-range-picker-actions>
      <button class="cancel" mat-button matDateRangePickerCancel>{{ 'text_cancel' | dbText }}</button>
      <button
              mat-raised-button
              color="primary"
              (click)="applySelectedDate(picker)"
              [disabled]="pickerService.applyDisabled | async"
              matDateRangePickerApply
      >
        {{ 'text_compare' | dbText }}
      </button>
    </mat-date-range-picker-actions>
    </mat-date-range-picker>
  </mat-form-field>
</div>
